import clsx from "clsx";
import { useGameStore } from "../store/useGameStore";

interface AdminAssetPathProps {
  path: string;
  className?: string;
}

/** Small monospace asset path — visible only to admins when the debug toggle is on. */
export function AdminAssetPath({ path, className }: AdminAssetPathProps) {
  const show = useGameStore((s) => s.adminShowAssetPaths);
  const isAdmin = useGameStore((s) => s.user?.is_admin);

  if (!show || !isAdmin || !path) return null;

  return (
    <div
      className={clsx(
        "text-[9px] font-mono text-amber-400/85 break-all leading-tight select-all",
        className,
      )}
      title={path}
    >
      {path}
    </div>
  );
}
